/**
 * KanbanIndicator — 0258 D2: Indicador cuando Kanban con Agenda activa
 * Muestra perfil activo y que las tarjetas se mueven automáticamente.
 */
import React from "react";
import { Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const useStyles = makeStyles((theme) => ({
  indicator: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.success.light,
    borderLeft: `4px solid ${theme.palette.success.main}`,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  icon: {
    color: theme.palette.success.main,
    fontSize: 24,
    flexShrink: 0,
  },
  text: {
    fontWeight: 500,
  },
  subtext: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
}));

export default function KanbanIndicator({ groupName, agendaActive }) {
  const classes = useStyles();

  const title = groupName
    ? `Kanban activo: ${groupName}`
    : "Kanban activo";

  const subtitle = agendaActive
    ? "Las tarjetas se mueven automáticamente al cambiar el estado de la cita."
    : "Visualiza y gestiona tus tickets por columnas de etiquetas.";

  return (
    <Paper className={classes.indicator} elevation={0}>
      <CheckCircleIcon className={classes.icon} />
      <div>
        <Typography variant="subtitle2" className={classes.text}>
          {title}
        </Typography>
        <Typography variant="caption" className={classes.subtext}>
          {subtitle}
        </Typography>
      </div>
    </Paper>
  );
}
